import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-50 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end" }
const _hoisted_2 = { class: "max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden" }
const _hoisted_3 = { class: "p-4" }
const _hoisted_4 = { class: "flex items-start" }
const _hoisted_5 = { class: "flex-shrink-0" }
const _hoisted_6 = { class: "ml-3 w-0 flex-1 pt-0.5" }
const _hoisted_7 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_8 = { class: "ml-4 flex-shrink-0 flex" }



interface Notification {
  id: string;
  type: 'success' | 'error';
  title: string;
  message: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Notification',
  props: {
    notification: {}
  },
  emits: ["close"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass([
                'w-10 h-10 rounded-full flex items-center justify-center',
                _ctx.notification.type === 'success' ? 'bg-green-100' : 'bg-red-100'
              ])
            }, [
              _createElementVNode("i", {
                class: _normalizeClass([
                  'text-lg',
                  _ctx.notification.type === 'success' ? 'fa-solid fa-check text-green-600' : 'fa-solid fa-exclamation-triangle text-red-600'
                ])
              }, null, 2)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", {
              class: _normalizeClass([
                'text-sm font-medium',
                _ctx.notification.type === 'success' ? 'text-green-900' : 'text-red-900'
              ])
            }, _toDisplayString(_ctx.notification.title), 3),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.notification.message), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
              class: "bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("span", { class: "sr-only" }, "Close", -1),
              _createElementVNode("i", { class: "fa-solid fa-times text-lg" }, null, -1)
            ]))
          ])
        ])
      ])
    ])
  ]))
}
}

})